import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  STEP_CALENDAR,
  STEP_PRODUCT,
  STEP_CONFIRM_PRICING,
  STEP_CUSTOMER_DETAILS,
  STEP_PAYMENT,
  triggerWindowResize,
  changeCurrentStep,
  fetchOrderData,
  initializeMainView,
} from '../actions'
import isConfirmPricingStepEnabledSelector from '../selectors/isConfirmPricingStepEnabledSelector'
import orderSelector from '../selectors/orderSelector'
import NewOrderScheduleForm from './NewOrderScheduleForm'
import NewOrderProductForm from './NewOrderProductForm'
import NewOrderCustomerDetailsForm from './NewOrderCustomerDetailsForm'
import NewOrderConfirmPricingForm from './NewOrderConfirmPricingForm'
import NewOrderPaymentForm from './NewOrderPaymentForm'
import SidebarSectionOrder from '../components/SidebarSectionOrder'
import SidebarSectionProduct from '../components/SidebarSectionProduct'
import OrderSummary from '../components/OrderSummary'
import FormStep from '../components/FormStep'

const mapStateToProps = (state) => {
  return {
    order: orderSelector(state),
    currentStep: state.currentStep,
    loadingStep: state.loadingStep,
    isConfirmPricingStepEnabled: isConfirmPricingStepEnabledSelector(state),
    isWidgetView: state.isWidgetView,
    fetchOrderLoading: state.fetchOrderLoading,
    fetchOrderDone: state.fetchOrderDone,
    fetchOrderFailed: state.fetchOrderFailed,
    initializeViewLoading: state.initializeViewLoading,
  }
};

const mapDispatchToProps = dispatch => bindActionCreators({
  triggerWindowResize,
  changeCurrentStep,
  fetchOrderData,
  initializeMainView,
}, dispatch)

class MainView extends React.Component {
  _isMounted = false
  subscriptions = []

  componentDidMount() {
    this._isMounted = true

    if (this.props.isWidgetView) {
      this._setupFetchOnWindowScrollHandler()
    } else {
      this._setupOnWindowResizeHandler()
      this._setupBackgroundRefreshHandler()
      this.props.initializeMainView()
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.subscriptions.forEach(s => s.unsubscribe())
    this.subscriptions.length = 0
  }

  handleGoToStepClick(step) {
    if (this.props.loadingStep) { return; }
    this.props.changeCurrentStep(step);
  }

  handleFormSave(step, orderData) {
    this.props.changeCurrentStep(step + 1);
  }

  _setupFetchOnWindowScrollHandler() {
    const onWindowScroll = () => {
      if (!this._alreadyFetched && this._containerRef && st.domUtils.isElementInViewport(this._containerRef)) {
        this._alreadyFetched = true
        this.props.initializeMainView()
      }
    }

    onWindowScroll()
    $(window).on("scroll", onWindowScroll)
    this.subscriptions.push({
      unsubscribe: () => $(window).off("scroll", onWindowScroll)
    })
  }

  _setupOnWindowResizeHandler() {
    const handleWindowResize = () => {
      this.props.triggerWindowResize({
        width: $(window).width()
      })
    }

  handleWindowResize()
    $(window).on("resize", handleWindowResize)
    this.subscriptions.push({
      unsubscribe: () => $(window).off("resize", handleWindowResize)
    })
  }

  _setupBackgroundRefreshHandler() {
    const handleBackgroundRefresh = () => {
      if (this.props.order && !this.props.order.still_building && this.props.order.data.waiting_for_confirmation_online_payment && this.props.order.data._hasPaymentFinished) {
        this.props.fetchOrderData()
      }
    }

    const interval = setInterval(handleBackgroundRefresh, 15 * 1000);
    this.subscriptions.push({
      unsubscribe: () => clearInterval(interval)
    })
  }

  renderSidebarViewContents() {
    if (!this.props.order || this.props.fetchOrderLoading) {
      return (
        <div className="NewOrderView-sidebar-contents"></div>
      );
    } else {
      return (
        <div className="NewOrderView-sidebar-contents">
          <h3 className="sidebar-title hidden-xs hidden-sm">{this.props.order.still_building ? I18n.t("fe.NewOrderView.building") : I18n.t("fe.NewOrderView.built")}</h3>
          <h3 className="sidebar-title visible-xs visible-sm">
            {this.props.order.still_building ? `${I18n.t("fe.NewOrderView.building")}: ` : `${I18n.t("fe.NewOrderView.built")}: `}
            {!this.props.order.product && <span>{this.props.order.data.product_name}</span>}
            {!!this.props.order.product && <a href={this.props.order.product.url}>{this.props.order.data.product_name}</a>}
          </h3>

          <SidebarSectionProduct order={this.props.order} />
          {this.props.currentStep >= STEP_PRODUCT && (
            <SidebarSectionOrder order={this.props.order} showOrderDetails={this.props.currentStep >= STEP_CUSTOMER_DETAILS} />
          )}
        </div>
      );
    }
  }

  renderMainViewContents() {
    if (this.props.order && this.props.fetchOrderFailed) {
      const contact_email = (this.props.order.data.app_config && this.props.order.data.app_config.contact_email) || "info@tripsomnia.com"
      return (
        <div className="alert alert-danger NewOrderView-loading-alert">
          <p>{I18n.tt(`fe.NewOrderView.loading_failed`)}</p>
          <p>{I18n.tt(`fe.NewOrderView.contact_us_if_problem_repeats`, {
              email: <a href={`mailto:${contact_email}`}>{contact_email}</a>
          })}</p>
        </div>
      );
    } else if (!this.props.order || this.props.fetchOrderLoading || (this.props.order.still_building && !this.props.currentStep) || this.props.initializeViewLoading) {
      return (
        <div className="alert alert-info NewOrderView-loading-alert">
          {I18n.t("fe.NewOrderView.loading_in_progress")}
        </div>
      );
    } else if (this.props.order.still_building) {
      let stepI = 0;

      return (
        <div className="NewOrderView-content">
          <div className="form--steps">
            {this.props.order.data.booking_type !== "no_booking" &&
              <FormStep
                i={stepI += 1}
                name="calendar"
                title={I18n.t("fe.NewOrderView.choose_date_step_title")}
                isActive={this.props.currentStep === STEP_CALENDAR}
                isDisabled={this.props.currentStep < STEP_CALENDAR}
                onGoToStepClick={this.handleGoToStepClick.bind(this, STEP_CALENDAR)}
                isLoading={this.props.loadingStep === STEP_CALENDAR}>
                {this.props.currentStep === STEP_CALENDAR && (
                  <NewOrderScheduleForm
                    onSave={this.handleFormSave.bind(this, STEP_CALENDAR)} />
                )}
              </FormStep>}

            {!(this.props.order.product && this.props.order.product.product_type === "coupon" && this.props.currentStep >= STEP_CUSTOMER_DETAILS) && (
              <FormStep
                i={stepI += 1}
                name="product"
                title={I18n.t("fe.NewOrderView.fill_order_step_title")}
                isActive={this.props.currentStep === STEP_PRODUCT}
                isDisabled={this.props.currentStep < STEP_PRODUCT}
                onGoToStepClick={this.handleGoToStepClick.bind(this, STEP_PRODUCT)}
                isLoading={this.props.loadingStep === STEP_PRODUCT}>
                {this.props.currentStep === STEP_PRODUCT && (
                  <NewOrderProductForm
                    onSave={this.handleFormSave.bind(this, STEP_PRODUCT)} />
                )}
              </FormStep>
            )}

            {this.props.isConfirmPricingStepEnabled && !(this.props.order.product && this.props.order.product.product_type === "coupon" && this.props.currentStep >= STEP_CUSTOMER_DETAILS) &&
              <FormStep
                i={stepI += 1}
                name="confirm-pricing"
                title={I18n.t("fe.NewOrderView.confirm_payment_details_step_title")}
                isActive={this.props.currentStep === STEP_CONFIRM_PRICING}
                isDisabled={this.props.currentStep < STEP_CONFIRM_PRICING}
                onGoToStepClick={this.handleGoToStepClick.bind(this, STEP_CONFIRM_PRICING)}
                isLoading={this.props.loadingStep === STEP_CONFIRM_PRICING}>
                {this.props.currentStep === STEP_CONFIRM_PRICING && (
                  <NewOrderConfirmPricingForm
                    onSave={this.handleFormSave.bind(this, STEP_CONFIRM_PRICING)} />
                )}
              </FormStep>}

            <FormStep
              i={stepI += 1}
              name="customer-details"
              title={I18n.t("fe.NewOrderView.fill_customer_details_step_title")}
              isActive={this.props.currentStep === STEP_CUSTOMER_DETAILS}
              isDisabled={this.props.currentStep < STEP_CUSTOMER_DETAILS}
              onGoToStepClick={this.handleGoToStepClick.bind(this, STEP_CUSTOMER_DETAILS)}
              isLoading={this.props.loadingStep === STEP_CUSTOMER_DETAILS}>
              {this.props.currentStep === STEP_CUSTOMER_DETAILS && (
                <NewOrderCustomerDetailsForm
                  onSave={this.handleFormSave.bind(this, STEP_CUSTOMER_DETAILS)} />
              )}
            </FormStep>

            {(this.props.order.data.confirmation_installment_before_company_approval || this.props.order.data.confirmation_installment_without_company_approval) &&
              <FormStep
                i={stepI += 1}
                name="payment"
                title={I18n.t("fe.NewOrderView.make_online_payment_step_title")}
                isActive={this.props.currentStep === STEP_PAYMENT}
                isDisabled={this.props.currentStep < STEP_PAYMENT}
                onGoToStepClick={this.handleGoToStepClick.bind(this, STEP_PAYMENT)}
                isLoading={this.props.loadingStep === STEP_PAYMENT}>
                {this.props.currentStep === STEP_PAYMENT && (
                  <NewOrderPaymentForm
                    onSave={this.handleFormSave.bind(this, STEP_PAYMENT)} />
                )}
              </FormStep>}
          </div>
        </div>
      );
    } else {
      return (
        <div className="NewOrderView-content">
          <OrderSummary order={this.props.order} />
        </div>
      );
    }
  }

  cookieCheck() {
    if (!navigator.cookieEnabled){
      return(
        <div className="alert alert-danger">
          Please <b>enable cookies</b> to use reservation form
        </div>
      )
    }
  }

  render() {
    return (
      <div
        className={classNames("NewOrderView", {
          "has-selected-product-variant": this.props.currentStep >= STEP_PRODUCT,
          "new-order-widget-view": this.props.isWidgetView,
          "new-order-full-view": !this.props.isWidgetView
        })}
        ref={ref => this._containerRef = ref}>
        <div className="NewOrderView-inner">
          <div className="NewOrderView-sidebar">
            {this.renderSidebarViewContents()}
          </div>

          <div className="NewOrderView-main">
            <div>
              {this.cookieCheck()}
              {this.renderMainViewContents()}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const ConnectedMainView = connect(
  mapStateToProps,
  mapDispatchToProps
)(MainView)

export default ConnectedMainView



// WEBPACK FOOTER //
// ./app/webpack/frontend/features/NewOrderView/containers/MainView.jsx